// extracted by mini-css-extract-plugin
export default {"main":"FreeBook_main__92asp","imgCont":"FreeBook_imgCont__HBb8g","contentCont":"FreeBook_contentCont__W8SMe","form":"FreeBook_form__Erb5Z"};